import { useId } from 'react'
import { Link } from 'react-router'
import styles from './DecisionPatterns.module.css'

export function ContextReferenceList({
  items = [],
  title = 'Review context',
  description,
  className = '',
}) {
  const titleId = useId()

  if (!items.length) return null

  return (
    <section className={`${styles.section} ${className}`.trim()} aria-labelledby={titleId}>
      <div className={styles.sectionHeading}>
        <h3 id={titleId} className={styles.sectionTitle}>{title}</h3>
        {description ? <p className={styles.sectionDescription}>{description}</p> : null}
      </div>
      <dl className={styles.contextList}>
        {items.map((item) => (
          <div key={item.key || item.label} className={styles.contextRow}>
            <dt>{item.label}</dt>
            <dd>{item.href ? <Link to={item.href}>{item.value}</Link> : item.value}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
